import { render, staticRenderFns } from "./HeroDropdown.vue?vue&type=template&id=6ff2812c&scoped=true"
import script from "./HeroDropdown.vue?vue&type=script&lang=js"
export * from "./HeroDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff2812c",
  null
  
)

export default component.exports